export default __webpack_public_path__ + "static/media/previewMobile.2edf47c8.png";